module.exports = __webpack_public_path__ + "static/img/1.b8a9f6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v15_new_features/1.png
// module id = I36k
// module chunks = 0